import { ReduxState } from 'src/store/types';

export const namedGraphsByModelSelector =
  (databaseId: string) => (state: ReduxState) =>
    state.databases.databasesById[databaseId]?.namedGraphsByModel || {};
